import React, { useContext } from "react";
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Grid,
    useMediaQuery,
    useTheme
} from "@material-ui/core";
import { useStores } from "../../../../../hooks";
import { FormControl, Typography } from "../../../../../common/components/libs";
import { observer } from "mobx-react";
import OrderSettingsPageStoreContext from "../context";
import { useTranslation } from "react-i18next";
import { MenuType, ReportingFilterType } from "../../../../../services/menu/models";
import { OrderStatus } from "../../../../../services/orders/models";


const EditTelegramNotifications = () => {
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.up('sm'));
    const {t} = useTranslation(["general", "menu"]);
    const { generalMenuStore } = useStores();

    const store = useContext(OrderSettingsPageStoreContext);
    const { open, current } = store.forms.editTelegramNotifications;


    if (!current) return;

    const closeForm = async () => {
        await generalMenuStore.fetchMenus(MenuType.regular);
        await generalMenuStore.fetchMenus(MenuType.booking);
        store.closeEditTelegramNotifications();
    };

    const filters = current.filters.map(item => item.type);
    const filtersMap = current.filters.reduce((memo, filter) => {
        memo[filter.type] = filter;
        return memo;
    }, {})

    const chooseFilter = (type: ReportingFilterType) => () => {

        if (type === ReportingFilterType.callWaiterForTable && filters.indexOf(type) < 0) {
            store.setFilters([
                ...current.filters,
                {type: ReportingFilterType.callWaiterForTable}
            ])
        } else if (type === ReportingFilterType.callWaiterForTable && filters.indexOf(type) >= 0) {
            store.setFilters(
                current.filters.filter(item => {
                    return item.type !== type
                })
            )
        } else if (type === ReportingFilterType.whitelistedOrderStatuses &&
            !filtersMap[ReportingFilterType.whitelistedOrderStatuses]?.orderStatuses.length) {

            if(!filtersMap[ReportingFilterType.whitelistedOrderStatuses]){
                store.setFilters([
                    ...current.filters,
                    {
                        type: ReportingFilterType.whitelistedOrderStatuses,
                        orderStatuses: [OrderStatus.new]
                    }
                ])
            }else{
                const newFilters = current.filters.map(item => {
                    if(item.type === type) {
                        return {
                            ...item,
                            orderStatuses: [OrderStatus.new]
                        }
                    }else{
                        return item;
                    }
                });
                store.setFilters(newFilters);
            }

        } else if (type === ReportingFilterType.whitelistedOrderStatuses &&
            filtersMap[ReportingFilterType.whitelistedOrderStatuses]?.orderStatuses.length) {

            const newFilters = current.filters.map(item => {
                if(item.type === type) {
                    return {
                        ...item,
                        orderStatuses: []
                    }
                }else{
                    return item;
                }
            });
            store.setFilters(newFilters)
        }
    }


    return (
        <Dialog
            open={open}
            onClose={closeForm}
            aria-labelledby="form-dialog-title"
            fullWidth={true}
            maxWidth={"sm"}
            fullScreen={!isSm}
        >
            <DialogTitle id="form-dialog-title">
                {t("menu:orderSettingsPage.chooseNotifications")}
            </DialogTitle>
            <DialogContent>
                <Grid container direction="column">
                    <FormControl>
                        <FormControlLabel
                            value={ReportingFilterType.whitelistedOrderStatuses}
                            key="offline"
                            control={<Checkbox
                                checked={
                                    filtersMap[ReportingFilterType.whitelistedOrderStatuses]?.orderStatuses.length
                                }
                                onChange={chooseFilter(ReportingFilterType.whitelistedOrderStatuses)}
                            />}
                            label={
                                <Typography variant={'h6'}>
                                    {t("menu:orderSettingsPage.ordersNotifications")}
                                </Typography>}
                        />
                    </FormControl>

                    <FormControl>
                        <FormControlLabel
                            value={ReportingFilterType.callWaiterForTable}
                            key="offline"
                            control={<Checkbox
                                checked={filters.indexOf(ReportingFilterType.callWaiterForTable)>=0}
                                onChange={chooseFilter(ReportingFilterType.callWaiterForTable)}
                            />}
                            label={
                                <Typography variant={'h6'}>
                                    {t("menu:orderSettingsPage.waiterNotifications")}
                                </Typography>}
                        />
                    </FormControl>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained'
                        onClick={closeForm}
                >
                    {t("general:close")}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
export default observer(EditTelegramNotifications);
